import catalogEn from '../locale/en/messages.js';

// Compiled catalogs required by jsLingui

export const InitialState = {
  language: 'en',
  catalogs: {
    en: catalogEn,
  },
};

export const model = {
  state: InitialState,

  reducers: {
    mergeMessagesIntoCatalogs(state, payload) {
      const nextState = {
        ...state,
        catalogs: {
          ...state.catalogs,
        },
      };

      Object.entries(payload).forEach(([language, messageBag]) => {
        // $FlowExpectedError
        const lang = language.toLowerCase();
        nextState.catalogs[lang].messages = {
          ...nextState.catalogs[lang].messages,
          ...messageBag,
        };
      });

      return nextState;
    },
  },

  selectors: {
    catalogs: (state) => state.catalogs,
    language: (state) => state.language,
  },
};
